import { render, staticRenderFns } from "./formItem.vue?vue&type=template&id=4d69adf8&scoped=true"
import script from "./formItem.vue?vue&type=script&lang=js"
export * from "./formItem.vue?vue&type=script&lang=js"
import style0 from "./formItem.vue?vue&type=style&index=0&id=4d69adf8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d69adf8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d69adf8')) {
      api.createRecord('4d69adf8', component.options)
    } else {
      api.reload('4d69adf8', component.options)
    }
    module.hot.accept("./formItem.vue?vue&type=template&id=4d69adf8&scoped=true", function () {
      api.rerender('4d69adf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/salesControl/cooperation/components/formItem.vue"
export default component.exports